export default "__VITE_ASSET__6fc1c1e5__"